
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default Vue.extend({
  name: 'Logo',
  props: {
    beta: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      theme: 'theme',
    }),
    fill(): string {
      return this.theme === 'dark' ? '#F83C45' : '#EE0026'
    },
  },
})
